import {Divider, Typography} from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import {getJobTypeByValue} from "./JobCard";


const MoreJobsCard = ({job, clientId}) => {

    const navigateToJob = () => {
        window.location.href = `/JobDetails?clientId=${clientId}&jobHash=${job.hashedCode}`
    }

    return (
        <Box padding={2} spacing={3} onClick={navigateToJob}>
            <Typography variant="h2" fontWeight="bold">
                {job.jobTitle}
            </Typography>
            <Box sx={{marginY: 1}}>
                <Grid container direction={"row"} spacing={2}>
                    {job.jobDetails.jobPlacement.map((city, index) => (
                        <Grid item xs={4} key={index}>
                            <Chip
                                variant={"outlined"}
                                label={(city)}
                                style={{width: '100%', color: '#FF6600', borderColor: '#FF6600'}}
                            />
                        </Grid>
                    ))}
                    <Grid item xs={4}>
                        <Chip variant={"outlined"} label={getJobTypeByValue(job.jobDetails.jobType)}
                              style={{width: '100%', color: '#015F5F', borderColor: '#015F5F'}}/>
                    </Grid>
                </Grid>
            </Box>
            <Typography variant="body2" color="text.secondary">
                {job.jobDetails.description}
            </Typography>
            <br/>
            <Divider sx={{backgroundColor: 'black'}}/>
        </Box>

    );
}

export default MoreJobsCard